<template>
  <tabs parent="storage_list">
    <tab id="devices" :name="translate('storage.devices')" :href="url + '/devices'">
      <keep-alive>
        <StorageDevices />
      </keep-alive>
    </tab>
    <tab v-if="$store.getters.getPermissions.permissionGod" id="components" :name="translate('storage.components.title')" :href="url + '/components'">
      <StorageComponents />
    </tab>
  </tabs>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import StorageDevices from './Tabs/Devices/Index.vue'
import StorageComponents from './Tabs/Components/Index.vue'

export default {
  name: 'StorageList',
  components: {
    Tabs,
    Tab,
    StorageDevices,
    StorageComponents
  },
  computed: {
    url () { return '/storage_list' }
  }
}
</script>
